<template>

  <svg
    t="1639124529853"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="3965"
    width="64"
    height="64"
  ><path d="M416 160c-35.008 0-64 28.992-64 64v64H64v576h896V288h-288V224c0-35.008-28.992-64-64-64z m0 64h192v64h-192z m-288 128h768v160h-128v-32h-128v32h-256v-32H256v32H128z m0 224h128v32h128v-32h256v32h128v-32h128v224H128z" p-id="3966" /></svg>


</template>

<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'JtIconToolbox',
} as DefineComponent
</script>